import * as util from 'util';
import _ from 'lodash';
import {RouteService} from "../../../../services/routeService";
import {NotificationService} from "../../../../services/notificationService";
import {GeneralService} from "../../../../services/generalService";
import {DICTIONARY} from "../../../../dictionary";
import {Component, OnInit} from "@angular/core";

@Component({
	selector: 'app-collaboration-protection-reviewers',
	templateUrl: './collaboration-protection-reviewers.component.html'
})
export class CollaborationProtectionReviewersComponent implements OnInit {
	constructor(private rs:RouteService,
				private ns:NotificationService,
				public gs:GeneralService){
	}

	dic = DICTIONARY;

	reviewers;
	userInfo;
	isLoaded = false;
	selectedUsers: any[];
	usersSelectionPopup: any;
	reviewerPermissionPopup;
	addReviewerInProcess;

	ngOnInit() {
		this.gs.getUserInfo(false, (userInfo) => {
			this.userInfo = userInfo;
		});

		this.rs.getCollaborationConfiguration().then(response => {
			this.reviewers = response.collaboration_protection.reviewers;
			this.isLoaded = true;
		}, (err) => {
			this.isLoaded = true;
		});
	};

	showReviewerActions = (reviewerObj) => {
		let actions = [
			this.dic.CONSTANTS.reviewerActions.modifyPermissions,
			this.dic.CONSTANTS.inboundConfigurationsActions.remove
		];

		return actions;
	}

	showReviewerBulkActions = () => {
		return [
			this.dic.CONSTANTS.inboundConfigurationsActions.remove
		];
	}

	selectReviewerAction = (reviewerObj, action) => {
		reviewerObj.showActions = false;
		switch (action) {
			case this.dic.CONSTANTS.inboundConfigurationsActions.remove:
				this.removeReviewers([reviewerObj]);
				break;

			case this.dic.CONSTANTS.reviewerActions.modifyPermissions:
				this.openReviewerPermissionPopup(reviewerObj);
				break;
		}
	};

	selectMultipleReviewerAction = (selectedItems, action) => {
		switch (action) {
			case this.dic.CONSTANTS.inboundConfigurationsActions.remove:
				this.removeReviewers(selectedItems);
				break;
		}
	};

	openReviewerPermissionPopup = (reviewerObj) => {
		this.reviewerPermissionPopup = {
			show: true,
			reviewerObj: reviewerObj
		};
	};

	reviewerChangeConfigurationExecute = () => {
		const actionInfo = {
			action: 'changeConfiguration',
			enabled: this.reviewerPermissionPopup.reviewerObj.allow_change_configuration
		};
		this.rs.updateCollaborationReviewer(this.reviewerPermissionPopup.reviewerObj.email, actionInfo).then(res => {
			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
		});
	};

	reviewerViewContentDlpExecute = () => {
		const actionInfo = {
			action: 'viewContent',
			type: 'DLP',
			enabled: this.reviewerPermissionPopup.reviewerObj.allow_view_content_dlp
		};
		this.rs.updateCollaborationReviewer(this.reviewerPermissionPopup.reviewerObj.email, actionInfo).then(res => {
			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
		});
	};

	reviewerViewContentMaliciousExecute = () => {
		const actionInfo = {
			action: 'viewContent',
			type: 'Malicious',
			enabled: this.reviewerPermissionPopup.reviewerObj.allow_view_content_malicious
		};
		this.rs.updateCollaborationReviewer(this.reviewerPermissionPopup.reviewerObj.email, actionInfo).then(res => {
			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
		});
	};

	reviewerViewContentRulesExecute = () => {
		const actionInfo = {
			action: 'viewContent',
			type: 'Rules',
			enabled: this.reviewerPermissionPopup.reviewerObj.allow_view_content_rules
		};
		this.rs.updateCollaborationReviewer(this.reviewerPermissionPopup.reviewerObj.email, actionInfo).then(res => {
			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
		});
	};

	openUsersSelection = () => {
		this.selectedUsers = _.map(this.reviewers, 'email');
		this.usersSelectionPopup = {
			show: true
		};
	}

	addExistUsersToReviewers(users) {
		// Step 1: Filter out existing reviewers
		const existingEmails = _.map(this.reviewers, 'email');
		const filteredUsers = users.filter(user => !existingEmails.includes(user));

		// Step 2: Map filtered users to new reviewers structure
		const newReviewers = filteredUsers.map(user => ({
			email: user,
			isEditMode: false,
			isNew: true,
			edit: {
				email: user,
				allow_change_configuration: true
			}
		}));

		if (newReviewers.length) {
			const options = {flags: {allow_change_configuration: true}};
			newReviewers.forEach(user => {
				this.rs.addCollaborationReviewer(user.email, options).then(res => {
					this.reviewers.push({email: user.email, allow_change_configuration: true});
					this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemAdded, user.email));
				});
			});
		}
	};

	startRemoveFromUsersSelection = (users) => {
		const reviewersToRemove = this.reviewers.filter(reviewer => users.includes(reviewer.email));

		if (reviewersToRemove.length > 0) {
			this.removeReviewers(reviewersToRemove);
		}
	}

	removeReviewers = (reviewers) => {
		if (!reviewers || !reviewers.length) {
			return;
		}

		let title, subTitle, body;
		if (reviewers.length === 1) {
			body = ['User will not have permission to access Collaboration Protection pages any more'];
			title = 'Remove Reviewer';
			subTitle = `Remove ${reviewers[0].email} as a reviewer from Collaboration Protection`;
		}
		else {
			body = [`Users will not have permission to access Collaboration Protection pages any more`];
			title = `Remove reviewing permission`;
			subTitle = `Remove ${reviewers.length} reviewers from Collaboration Protection`;
		}

		this.gs.showPopup({
			title: title,
			subTitle: subTitle,
			body: body,
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Remove',
			doneCb: () => {
				_.map(reviewers, reviewer => {
					const _reviewerObj = _.find<any>(this.reviewers, itm => itm.email === reviewer.email);
					if (_reviewerObj) {
						this.rs.deleteCollaborationReviewer(reviewer.email).then(res => {
							_.remove<any>(this.reviewers, _reviewerObj);

							this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemDeleted, 'Reviewer', reviewer.email));
						});
					}
				});
			}
		});
	};

	startAddReviewer() {
		if (this.addReviewerInProcess) {
			return;
		}

		this.addReviewerInProcess = true;

		const newReviewer = {
			isEditMode: true,
			isNew: true,
			edit: {
				email: '',
				allow_change_configuration: true,
			}
		};

		this.reviewers.unshift(newReviewer);
	};

	confirmAddReviewer = (reviewer ,isApproved) => {
		// new reviewer process was declined
		if (!isApproved) {
			_.remove<any>(this.reviewers, reviewer);
			this.addReviewerInProcess = false;
			return;
		}
		//

		// new reviewer approved
		if (!reviewer.edit.email) {
			return this.ns.showErrorMessage(util.format(this.dic.ERRORS.accountEmailMissingName, 'Reviewer email field'));
		}
		if (!this.gs.validateEmail(reviewer.edit.email)) {
			return this.ns.showErrorMessage(util.format(this.dic.ERRORS.invalidEmail, reviewer.edit.email));
		}
		if (_.find(this.reviewers, rev => {return !rev.isNew && rev.email && rev.email === reviewer.edit.email})) {
			return this.ns.showErrorMessage(util.format(this.dic.ERRORS.emailAlreadyExist, reviewer.edit.email));
		}
		reviewer.confirmEditInProcess = true;
		const emailFormatted = reviewer.edit.email.toLowerCase();
		const options = {flags: {allow_change_configuration: true}};
		this.rs.addCollaborationReviewer(emailFormatted, options).then(res => {
			this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemAdded, 'Reviewer'));

			reviewer.email = emailFormatted;
			reviewer.allow_change_configuration = true;
			reviewer.edit = null;
			reviewer.confirmEditInProcess = false;
			reviewer.isEditMode = false;
			reviewer.isNew = undefined; // keep it 'undefined' and not 'false' for sticking the item to the top of the table only when in edit

			this.addReviewerInProcess = false;
		}, (err) => {
			reviewer.confirmEditInProcess = false;
			this.addReviewerInProcess = false;
		});
	};

	searchReviewer = (searchTerm, activeFilters) => {
		this.reviewers.forEach(record => {
			// search
			if (searchTerm) {
				const isFound = searchTextExecute(record, searchTerm);
				if (!isFound) {
					record.hide = true;
					return;
				}
			}

			record.hide = false;
		});
	};
}

function searchTextExecute(reviewer, searchTerm) {
	return (reviewer.email?.toLowerCase().indexOf(searchTerm) > -1);
}
